import { GROUPS, PREFIX_PROXY } from '@/service/apiConf';
import { get } from '@/service/request';

interface PersistentVolumeClaimParams {
  namespace: string;
}
/** 获取持久卷声明 */
export const getPersistentVolumeClaim = (
  cluster: string,
  params: PersistentVolumeClaimParams,
): Promise<any> => {
  return get(`${PREFIX_PROXY.vapis(GROUPS.persistentvolumeclaim)}/persistentvolumeclaims`, params);
};

interface GetStorageClassesParams {}
/** 获取存储类 */
export const getStorageClasses = (
  cluster: string,
  params?: GetStorageClassesParams,
): Promise<any> => {
  return get(`${PREFIX_PROXY.vapis(GROUPS.storage)}/storageclasses`, params);
};
